<template>
  <div class="section-article-title" v-if="showSection">
    <div class="static-color-boutique-tag" v-if="sectionData.tag" :style="{'background': '#' + sectionData.tag.color }" >{{sectionData.tag.name}}</div>
    <span class="text" :class="{'concept': isConcept}">{{sectionData.name}}</span>
  </div>
</template>

<script>
export default {
  props: {
    linkInfo: {
      type: Object,
      default: () => ({})
    },
    isConcept: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    showSection () {
      return this.linkInfo.title
    },
    sectionData () {
      return {
        name: this.linkInfo.title,
        tag: this.linkInfo.special_tag || null
      }
    },
  }
}
</script>

<style lang="less">
.section-article-title {
  color: #14191e;
  font-size: 0;
  font-weight: 500;
  line-height: 30px;
  text-align: justify;
  word-break: break-all;
  padding: 0 12px;
  .static-color-boutique-tag {
    display: inline-block;
    width: 64px;
    height: 34px;
    margin-right: 12px;
    vertical-align: middle;
    color: #fff;
    font-size: 22px;
    line-height: 34px;
    text-align: center;
    border-radius: 4px;
    zoom: .5;
  }
  .text {
    font-size: 20px;
    vertical-align: middle;
    &.concept {
      font-size: 17px;
      font-weight: 600;
    }
  }
  .hot {
    width: 22px;
    height: 22px;
    vertical-align: middle;
  }
}
</style>